import {useNavigate} from 'react-router-dom';
import {useTheme} from '@mui/material';
import {MY_APPOINTMENT_DETAILS_PATH} from 'presentation/modules/myAppointments/constants/appointmentDetailsPath';
import {AppointmentCardProps} from '../../AppointmentCard/types';

export const useAttachmentCard = ({appointment}: AppointmentCardProps) => {
	const navigate = useNavigate();
	const theme = useTheme();

	const handleGoToDetails = () => {
		navigate(
			MY_APPOINTMENT_DETAILS_PATH[appointment.bookingType].replace(
				':id',
				appointment.bookingNumber,
			),
		);
	};

	return {
		theme,
		handleGoToDetails,
	};
};
